<template>
  <div class="standings-wrapper">
    <header-pane
      :hasHeaderNav="true"
      :pageTitle="$tc('StandingsPage.pageTitle')"
      navigationCurrent="standings"
      colorType="light"
    />
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, onUnmounted } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import useRealtimeMessaging, { RTMCallbackParamType } from '@/components/hook/useRealtimeMessaging'
import Logger from '@/util/logger/Logger'
import StoreUtil from '@/store/StoreUtil'

/**
 * Standings 共通Wrapper
 */
export default defineComponent({
  name: 'StandingsPageWrapper',
  components: {
    HeaderPane,
  },
  setup() {
    const notificationStore = StoreUtil.useStore('NotificationStore')
    const { fetchNotificationData } = notificationStore
    // hook
    const { initRTM, subscribeRTM, unSubscribeRTM } = useRealtimeMessaging()

    onBeforeMount(async () => {
      // お知らせのリアルタイムメッセージを受信
      await initRTM()
      subscribeRTM('information', async (data: RTMCallbackParamType) => {
        Logger.debug(
          `StandingsPage#subscribeRTM: Receive notification event. event: ${JSON.stringify(data)}`,
        )
        fetchNotificationData()
      })
    })

    onUnmounted(() => {
      // お知らせに関連するリアルタイムメッセージ受信を停止
      unSubscribeRTM()
    })
  },
})
</script>

<style lang="scss" scoped>
.standings-wrapper {
  background: $gray1;
  min-height: var(--screen-height);
}
</style>

<style lang="scss">
.page-wrapper .standings-wrapper {
  .standings-top-pane,
  .standings-details-page {
    height: $mypageContentHeightPC;
  }

  .standings-list-section {
    height: calc(#{$mypageContentHeightPC} - 44px);
  }
}
</style>
